module.exports = __webpack_public_path__ + "static/media/Icn-pps.688ce35e.svg";